import AboutUs from "./HomeSections/Aboutus/AboutUs";
import ContactUs from "./HomeSections/ContactUs/contactUs";
import Gifts from "./HomeSections/Gifts/Gifts";
import Reviews from "./HomeSections/Reviews/reviews";
import Services from "./HomeSections/Services/services";
import VideoSlider from "./HomeSections/VideoSlider/videoSlider";
import ScrollToTopButton from "./HomeSections/buttonScroll"; 


export default function Home(){
    return (
                      <>
                        <section id="video-slider">
                          <VideoSlider />
                        </section>
                        <section id="about-us">
                          <AboutUs/>
                        </section>
                        <section id="services">
                          <Services />
                        </section>
                        <section id="gifts">
                          <Gifts />
                        </section>
                        <section id="reviews">
                          <Reviews />
                        </section>
                        <section id="contact">
                          <ContactUs />
                        </section>
                          <ScrollToTopButton />
                      </>
    )
}